import { axiosInstance } from "@/lib/axiosInstance";
import axios from "axios";
import { DashboardMetrics } from "../models/dashboard.model";



export async function fetchDashboardMetrics(startDate: string, endDate: string): Promise<DashboardMetrics> {
  try {
    const res = await axiosInstance.get(`/reports/dashboard?startDate=${startDate}&endDate=${endDate}`);
    const data = res.data;
    return {
      totalSales: data.totalSales ?? 0,
      totalOrders: data.totalOrders ?? 0,
      totalStaff: data.totalStaff ?? 0,
      totalServices: data.totalServices ?? 0,
    };
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data?.message || "Error fetching dashboard metrics"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
